import { type FC, useEffect, useState } from 'react';

import { selectMyTicketsByType } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { useCurrentLotteryTier, useWinnerTicketSteps } from '../../hooks';
import { TicketList } from '../TicketList/TicketList';

const MyTicketListForCurrentWinner: FC = () => {
  const currentTier = useCurrentLotteryTier();
  const { filteredValue } = useWinnerTicketSteps();
  const myTickets = useAppSelector((state) =>
    selectMyTicketsByType(state, currentTier),
  );
  const [list, setList] = useState(myTickets);

  useEffect(() => {
    if (!filteredValue) {
      setList(myTickets);
    } else {
      const currentList = myTickets?.filter(({ ticket }) =>
        ticket.startsWith(filteredValue),
      );

      setList(currentList);
    }
  }, [myTickets, filteredValue]);

  return (
    <TicketList
      variant="fill"
      className="gap-[2px]"
      list={list}
      ticketType={currentTier}
      itemMotionProps={{ animate: { opacity: 1 }, exit: { opacity: 0 } }}
    />
  );
};

export { MyTicketListForCurrentWinner };
